// utils.ts — shadcn-svelte support utilities (the genuine helper the CLI ships).
//
// `cn()` merges class lists (clsx) and resolves Tailwind conflicts (tailwind-merge)
// so a `class` prop passed to a component reliably overrides the component's own
// base classes. `WithElementRef` adds a bindable `ref` to an element's attributes.
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & {
  ref?: U | null;
};

export type WithoutChildren<T> = Omit<T, "children">;
export type WithoutChild<T> = Omit<T, "child">;
export type WithoutChildrenOrChild<T> = Omit<T, "children" | "child">;
